<template>
  <div>
    <h1>Getting Started</h1>

    <p>Please review these resources to help you get started quickly.</p>


    <v-row class="card-grid">
      <v-col cols="12" sm="4">
        <v-card class="d-flex" color="grey lighten-4">
          <v-icon size="50" class="d-flex">fa-info</v-icon>
          <v-card-title>Getting Started Guide</v-card-title>
          <v-card-text>
            <p>We have prepared a useful getting started guide with all materials you might need to get started quickly.</p>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary" href="https://corporatefitness.helpscoutdocs.com/article/130-create-event-quick-start">View Guide</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="d-flex" color="grey lighten-4">
          <v-icon size="50" class="d-flex">fa-user-headset</v-icon>
          <v-card-title>Join Demo / Q&amp;A session</v-card-title>
          <v-card-text>
            <p>Please join our weekly Teams call where we do a quick demo of our platform and you can ask any questions you might have during the Q&amp;A session.</p>
          </v-card-text>
          <v-card-actions>
            <v-dialog max-width="400px">
                <template v-slot:activator="{ on }">
                  <v-btn text color="primary" v-on="on">More Info</v-btn>
                </template>
                <v-card>
                  <v-card-title>Join Demo / Q&amp;A session</v-card-title>
                  <v-card-text>
                    Join our weekly Microsoft Teams call with a product demo and Q&amp;A call on the following times:
                  </v-card-text>
                  <v-divider class="mb-4" />
                  <v-card-text>
                    <ul>
                      <li>Every Thursday at 2pm ET</li>
                      <li>Every Thursday at 1pm CT</li>
                      <li>Every Thursday at noon MT</li>
                      <li>Every Thursday at 11am PT</li>
                    </ul>
                  </v-card-text>
                  <v-divider class="mb-4" />
                  <v-card-text>
                    You don't have to register to join, simply join at the times mentioned above using the invite link below.
                  </v-card-text>                  
                  <v-card-actions>
                    <v-btn color="secondary" text href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_ZjlkZGRjNmMtMTU5NC00ZWI1LTkzMGQtODQ3NzFkZDdmMzEx%40thread.v2/0?context=%7b%22Tid%22%3a%225d13c221-17e7-43a7-947f-7af95a0da1ca%22%2c%22Oid%22%3a%225670a436-02a4-4dab-a6bc-eae1123f8dc6%22%7d">Join on Teams</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>    
          </v-card-actions>
        </v-card>
      </v-col> 
      <v-col cols="12" sm="4">
        <v-card class="d-flex" color="grey lighten-4">
          <v-icon size="50" class="d-flex">fa-play</v-icon>
          <v-card-title>Start a Free Trial</v-card-title>
          <v-card-text>
            <p>You can create a free 14-day trial for up to 5 users. You can choose between 3 challenge modes and 2 pre-designed templates to help you get started in no-time. No credit card is needed.</p>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary" href="/start-trial">Start Trial</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="d-flex" color="grey lighten-4">
          <v-icon size="50" class="d-flex">fa-paper-plane</v-icon>
          <v-card-title>Contact Us</v-card-title>
          <v-card-text>
            <p>Feel free to reach out to us in case you have any further questions.</p>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary" to="/contact">Contact Us</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="d-flex" color="grey lighten-4">
          <v-icon size="50" class="d-flex">fa-rocket</v-icon>
          <v-card-title>Create Your Event</v-card-title>
          <v-card-text>
            <p>Create your event based on one of our Ready-To-Go challenges.</p>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary" to="/challenges">Create Event</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { EventBus } from '@/plugins/eventbus.js';
import { DateTime } from 'luxon'
import BigButton from "@/components/BigButton";
import eventManagerService from "@/services/eventManagerService";
import tenants from '@/data/tenants.config'
const tenant = tenants.current();

export default {
  name: "StartTrial",
  components: {
    BigButton,
  },
  props: {
  },
  data: function() {
    return {
      valid: true,
    };
  },
  created() {
  },
  mounted() {
    
  },
  methods: {
    
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },
  watch: {
  }
};
</script>

<style  lang="scss">
.card-grid {
  .col-12 { display: flex;}
  .v-card {
    display: flex;
    align-items: stretch !important;
    flex-wrap: wrap;
    flex-direction: column;
    .v-card__text { flex-grow: 1;}
  }
  .v-icon {
    margin-top: 20px;
  }
}
</style>